import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  carrierActions,
  httpRequestsOnErrorsActions,
  httpRequestsOnSuccessActions, mcActions,
} from 'store';
import {
  createInputsWrapper,
  EmailValidator,
  ErrorText,
  FindErrorItem,
  FindLoad,
  FindSuccessItem, PermissionsList, RolePermission,
  useGlobalStyles,
  useGlobalText, userType,
} from 'utils';
import {
  CreateChancel,
  Line,
  ValidationInput,
  EditSaveButtons,
  SelectInput,
  MaskInput, SelectTypeAutocomplete, FormatAddress,
} from 'components';
import moment from 'moment';
import { company, docker } from '../../carrierInfo/core';
import { CREATE_CARRIER, EDIT_CARRIER } from '../../../../store/carriers/carrier.types';
import { stateList } from '../../../../utils/jsons/country';
import { carrierIntegrationEnums, RenderDetails } from '../../carrierInfo/core/constants';
import { createVendorRequiredFields, renderGoHighwayInfoStatus } from './constants';
import { vendorEnums } from '../../../../pages';

const CREATE_TYPE = CREATE_CARRIER;
const EDIT_TYPE = EDIT_CARRIER;

export const EditCarrierInputs = ({ handleChangeName, info }) => {
  const { mcsList } = useSelector((state) => ({
    mcsList: state.mcs.mcsList,
  }));
  const mcFilteredList = mcsList?.mcs?.filter((i) => i?.authorityType === 'CARRIER');
  const globalText = useGlobalText();
  const globalStyles = useGlobalStyles();
  const globalScreens = createInputsWrapper();
  const dispatch = useDispatch();
  const history = useHistory();
  const [disables, setDisabled] = useState(!!info);
  const [mailingAddress, setMailingAddress] = useState(info?.mailingAddress ? info?.mailingAddress : {});
  const [address, setAddress] = useState(info?.address ? info?.address : {});
  const [error, setError] = useState('');
  const [inputs, setInputs] = useState(info ? { ...info } : {});
  const [email, setEmail] = useState('');
  const [remittanceEmail, setRemittancev] = useState('');
  const [remittanceEmail2, setRemittanceEmail2] = useState('');
  const actionType = info ? EDIT_TYPE : CREATE_TYPE;
  const loader = FindLoad(CREATE_TYPE);
  const success = FindSuccessItem(EDIT_TYPE);
  const backError = FindErrorItem(actionType);
  const errorText = backError?.error ? backError?.error : Array.isArray(backError?.error) ? backError?.error[0] : '';
  const pushInfo = history?.location?.state;
  const carrierInfo = RenderDetails(pushInfo?.vendorType)?.Information;

  useEffect(() => {
    if (info?.isFactored) {
      dispatch(mcActions.getMcs());
    }
  }, [info]);

  const removeError = () => {
    errorText && dispatch(httpRequestsOnErrorsActions.removeError(actionType));
  };

  useEffect(() => {
    if (success) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess('EDIT_CARRIER'));
      setDisabled(true);
    }
  }, [success]);

  useEffect(() => {
    return () => {
      removeError();
    };
  }, []);

  const handleChange = e => {
    setInputs(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    error === e.target.name && setError('');
    e.target.name === 'companyName' && handleChangeName(e.target.value);
    removeError();
    if (errorText === 'A Carrier with this Authority Number already exists.') {
      dispatch(httpRequestsOnErrorsActions.removeError('CARRIER_AUTHORITY_EXIST'));
    }
  };

  const handleCreate = () => {
    const phoneNumber = inputs?.phone && parseInt(inputs?.phone.replace(/[^0-9]/g, '')) + '';
    const secPhoneNumber = inputs?.secondaryPhone && parseInt(inputs?.secondaryPhone.replace(/[^0-9]/g, '')) + '';
    // const checkFactored = info?.isFactored ? !!inputs.loadMC : true;
    const factoredCarrier = info?.type === vendorEnums.FACTORED;
    const checkFactored = factoredCarrier ? !!inputs.loadMC : true;
    const checkDot = (info?.type === vendorEnums.FACTORED || info?.type === vendorEnums.CARRIER) ? inputs.dot : true;

    const data = {
      'firstName': inputs.firstName,
      'lastName': inputs.lastName,
      'email': inputs.email,
      'remittanceEmail': inputs.remittanceEmail ? inputs.remittanceEmail : null,
      'remittanceEmail2': inputs.remittanceEmail2 ? inputs.remittanceEmail2 : null,
      'phone': phoneNumber ? phoneNumber : null,
      'birthdate': inputs.birthdate ? moment(inputs?.birthdate).format('YYYY-MM-DD') : null,
      'dl': inputs.dl,
      'dlState': inputs.dlState,
      // 'shippingAddress': shippingAddress,
      'mailingAddress': mailingAddress,
      'companyName': inputs.companyName,
      'companyType': inputs.companyType,
      'docketType': inputs.docketType,
      'docketNumber': inputs.docketNumber,
      'taxId': inputs.taxId,
      'address': address,
    };

    inputs?.mcNumber ? data.mcNumber = inputs?.mcNumber : delete data.mcNumber;
    inputs?.dbaName ? data.dbaName = inputs?.dbaName : delete data.dbaName;
    inputs?.scac ? data.scac = inputs?.scac : delete data.scac;
    inputs?.intrastateNumber ? data.intrastateNumber = inputs?.intrastateNumber : delete data.intrastateNumber;


    inputs?.dot ? data.dot = inputs?.dot : '';
    inputs?.insuranceExpiry ? data.insuranceExpiry = inputs?.insuranceExpiry : '';
    inputs?.businessLicense ? data.businessLicense = inputs?.businessLicense : '';
    data.secondaryPhone = inputs?.secondaryPhone ? secPhoneNumber : null;


    if (info?.isFactored) {
      data.loadMC = inputs?.loadMC;
    }


    // if (inputs.firstName && inputs.lastName && inputs.email && !email && inputs.companyName && inputs.docketType && inputs.docketNumber && !remittanceEmail && checkFactored) {

    if (createVendorRequiredFields(inputs, pushInfo?.vendorType) && !email && !remittanceEmail && !remittanceEmail2 && checkFactored) {
      dispatch(carrierActions.editCarrier(info?.id, data));
    } else {
      const checkDocket = carrierInfo?.companyTypeList && !inputs.docketType ? 'docketType' : null;
      const checkDocketNumber = carrierInfo?.authorityNumberName && !inputs.docketNumber ? 'docketNumber' : null;

      setError(
        !inputs.firstName ? 'firstName' :
          !inputs.lastName ? 'lastName' :
            !inputs.email ? 'email' :
              !inputs.companyName ? 'companyName' :
                checkDocket ? 'docketType' :
                  carrierInfo?.authorityNumberName ? !inputs.docketNumber ? 'docketNumber' : null :
                    // checkDocketNumber ? 'docketNumber' :
                    !checkDot ? 'dot' :
                      // !inputs.docketNumber ? 'docketNumber' :
                      // !inputs.docketType ? 'docketType' :
                      !checkFactored ? 'loadMC' :
                        '',
      );
    }
  };

  const handleSetAddress = (ev) => {
    setAddress(ev);
    if (error === 'address') setError('');
  };

  const handleMailingAddress = (ev) => {
    setMailingAddress(ev);
    removeError();
    if (error === 'mailingAddress') setError('');
  };


  const handleChancel = () => {
    setDisabled(true);
    setInputs({ ...info });
    setMailingAddress(info?.mailingAddress);
    setAddress(info?.address);
    setError('');
    setEmail('');
    setRemittancev('');
    setRemittanceEmail2('');
    removeError();
  };

  return (
    <div className={globalScreens.createInputsWrapper}>

      <div className='space-between'>
        <div className='align-center'>
          {!info && <p className={globalText.title}>Carrier Information</p>}
        </div>
        {info && RolePermission([PermissionsList.CREATE_UPDATE_CARRIER?.code]) &&
          <EditSaveButtons
            margin={true}
            type={'EDIT_CARRIER'}
            handleChancel={handleChancel}
            handleSetEdit={() => setDisabled(false)}
            handleSaveInfo={handleCreate}
          />}
      </div>
      <div className={globalStyles.flexAble}>
        {info && <Line height={'auto'} />}
        <div className={globalStyles.fullWidth}>
          <div className={globalScreens.basicInfo}>
            <p className={globalText.smallText}>Basic Information</p>
            <div className={globalScreens.basicInfoInputs}>
              <ValidationInput
                className={info?.firstName && globalStyles.inputTextFieldBlue}
                style={globalStyles.simpleInput}
                variant={'outlined'}
                name={'firstName'}
                type={'text'}
                label={'First Name*'}
                typeError={error === 'firstName' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.firstName}
                disabled={disables}
              />
              <ValidationInput
                className={info?.lastName && globalStyles.inputTextFieldBlue}
                style={globalStyles.simpleInput}
                variant={'outlined'}
                name={'lastName'}
                type={'text'}
                label={'Last Name*'}
                typeError={error === 'lastName' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.lastName}
                disabled={disables}
              />
              {(userType === 'ADMIN' && !carrierInfo?.noDOB && !(info?.type === vendorEnums.CARRIER && info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY)) &&
                <ValidationInput
                  className={info?.birthdate && globalStyles.inputTextFieldBlue}
                  style={userType === 'ADMIN' ? globalStyles.simpleInput : globalStyles.simpleInputNoRight}
                  variant={'outlined'}
                  name={'birthdate'}
                  type={'date'}
                  typeError={error === 'birthdate' ? ErrorText.field : ''}
                  label={'Date of Birth'}
                  onChange={handleChange}
                  value={info?.birthdate ? moment(inputs.birthdate).format('YYYY-MM-DD') : inputs?.birthdate}
                  disabled={disables}
                />
              }
              <MaskInput
                styles={{ marginRight: 0 }}
                name='phone'
                label='Phone Number'
                value={inputs.phone}
                disables={disables}
                handleChange={handleChange}
                info={info?.phone}
                error={
                  error === 'phone' ? ErrorText.field :
                    errorText === 'phone must be a valid phone number' && ErrorText.phone}
              />
            </div>

            <div className={globalScreens.basicInfoInputs}>
              <MaskInput
                name='secondaryPhone'
                label='Secondary Number'
                value={inputs?.secondaryPhone}
                disables={disables}
                handleChange={handleChange}
                info={info?.secondaryPhone}
                error={
                  error === 'secondaryPhone' ? ErrorText.field :
                    errorText === 'secondaryPhone must be a valid phone number' && ErrorText.phone}
              />

              {(userType === 'ADMIN' && !carrierInfo?.noDL && !(info?.type === vendorEnums.CARRIER && info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY)) &&
                <ValidationInput
                  className={info?.dl && globalStyles.inputTextFieldBlue}
                  style={globalStyles.simpleInput}
                  variant={'outlined'}
                  name={'dl'}
                  type={'text'}
                  label={'Driver’s License'}
                  typeError={error === 'dl' ? ErrorText.field : ''}
                  onChange={handleChange}
                  value={inputs?.dl}
                  disabled={disables}
                />
              }
              {(userType === 'ADMIN' && !carrierInfo?.noIssIngState && !(info?.type === vendorEnums.CARRIER && info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY)) &&
                <SelectInput
                  className={info?.dlState && globalStyles.inputTextFieldBlue}
                  style={globalStyles.simpleInput}
                  disabled={disables}
                  name={'dlState'}
                  label={'Issuing State'}
                  handleSelect={handleChange}
                  value={inputs?.dlState}
                  list={stateList}
                  typeError={error === 'dlState' ? ErrorText.field : ''}
                  type={'id'}
                />
              }
              <ValidationInput
                className={info?.email && globalStyles.inputTextFieldBlue}
                validator={EmailValidator}
                variant={'outlined'}
                name={'email'}
                type={'email'}
                label={'Email Address*'}
                typeError={
                  error === 'email' ? ErrorText.field :
                    email === 'Not valid email' ? 'Not valid email' :
                      errorText === 'Carrier already exists' ? 'Carrier already exists' :
                        ''}
                sendBoolean={(bool) => bool === true ? setEmail('Not valid email') : setEmail('')}
                onChange={handleChange}
                value={inputs?.email}
                disabled={disables}
              />
            </div>

            <div className='inputs-gap'>
              <div className='flex-align-start' style={{ width: '50%' }}>
                {/*{carrierInfo?.usdot &&*/}
                {/*  <ValidationInput*/}
                {/*    className={info?.dot && globalStyles.inputTextFieldBlue}*/}
                {/*    disabled={disables}*/}
                {/*    style={globalStyles.simpleInput}*/}
                {/*    variant={'outlined'}*/}
                {/*    name={'dot'}*/}
                {/*    label={'USDOT*'}*/}
                {/*    type={'text'}*/}
                {/*    typeError={*/}
                {/*      error === 'dot' ? ErrorText.field : ''*/}
                {/*    }*/}
                {/*    onChange={handleChange}*/}
                {/*    value={inputs.dot}*/}
                {/*  />*/}
                {/*}*/}
                <ValidationInput
                  className={info?.remittanceEmail && globalStyles.inputTextFieldBlue}
                  style={globalStyles.simpleInput}
                  validator={EmailValidator}
                  variant={'outlined'}
                  name={'remittanceEmail'}
                  type={'email'}
                  label={'Remittance Email'}
                  typeError={error === 'remittanceEmail' ? ErrorText.field : remittanceEmail === 'Not valid email' ? 'Not valid email' : ''}
                  sendBoolean={(bool) => bool === true ? setRemittancev('Not valid email') : setRemittancev('')}
                  onChange={handleChange}
                  value={inputs?.remittanceEmail}
                  disabled={disables}
                />
                <ValidationInput
                  className={info?.remittanceEmail2 && globalStyles.inputTextFieldBlue}
                  style={globalStyles.simpleInputNoRight}
                  validator={EmailValidator}
                  variant={'outlined'}
                  name={'remittanceEmail2'}
                  type={'email'}
                  label={'Sec.Remittance Email'}
                  typeError={error === 'remittanceEmail2' ? ErrorText.field : remittanceEmail2 === 'Not valid email' ? 'Not valid email' : ''}
                  sendBoolean={(bool) => bool === true ? setRemittanceEmail2('Not valid email') : setRemittanceEmail2('')}
                  onChange={handleChange}
                  value={inputs?.remittanceEmail2}
                  disabled={disables}
                />
              </div>
              <div style={{ width: '50%' }}>
                {info?.isFactored &&
                  <>
                    {mcFilteredList?.length ?
                      <SelectTypeAutocomplete
                        style={globalStyles.simpleInput}
                        name={'loadMC'}
                        label={'name'}
                        type={'mcNumber'}
                        title={'Load MC Number*'}
                        handleSelect={handleChange}
                        defaultValue={inputs?.loadMC}
                        list={mcFilteredList}
                        disabled={disables}
                        error={error}
                        right={'0'}
                      />
                      :
                      <SelectTypeAutocomplete
                        style={globalStyles.simpleInput}
                        name={'loadMC'}
                        title={'Load MC Number*'}
                        list={[]}
                        disabled={disables}
                        right={'0'}
                      />
                    }
                  </>
                }
              </div>
            </div>


          </div>

          {/*{userType === 'ADMIN' &&*/}
          {/*  <div className={globalScreens.basicInfo}>*/}
          {/*    <p className={globalText.smallText}>Address</p>*/}
          {/*    <div className={globalScreens.basicInfoInputs}>*/}
          {/*      <FormatAddress*/}
          {/*        placeholder={'Physical Address'}*/}
          {/*        notRequired={true}*/}
          {/*        noBlue={!info?.shippingAddress}*/}
          {/*        setCurrentAddress={handleSetShippingAddress}*/}
          {/*        selectedAddress={info?.shippingAddress}*/}
          {/*        errorBoolean={error === 'shippingAddress'}*/}
          {/*        disabled={disables}*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*}*/}

          {userType === 'ADMIN' &&
            <div>
              <p className={globalText.smallText}>Mailing Address</p>
              {/*<RadioButtons*/}
              {/*  value={mailingShipping}*/}
              {/*  handleSelect={handleSelectMailingAddress}*/}
              {/*  disabled={disables}*/}
              {/*/>*/}
              <div className={globalScreens.basicInfoInputs}>
                <FormatAddress
                  placeholder={'Physical Address'}
                  notRequired={true}
                  noBlue={!info?.mailingAddress}
                  setCurrentAddress={handleMailingAddress}
                  selectedAddress={info?.mailingAddress}
                  errorBoolean={error === 'mailingAddress'}
                  disabled={disables}
                />
              </div>
            </div>
          }

          {!(info?.type === vendorEnums.CARRIER && info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY) &&
            <div className={globalScreens.basicInfo}>
              <p className={globalText.title}>Company Information</p>

              <p className={globalText.smallText}>Basic Information</p>
              <div className='carrier-inputs-wrapper'>

                <div className='input-wrapper'>
                  <ValidationInput
                    className={info?.companyName && globalStyles.inputTextFieldBlue}
                    style={globalStyles.simpleInputNoRight}
                    variant={'outlined'}
                    name={'companyName'}
                    type={'text'}
                    label={'Company Name*'}
                    typeError={error === 'companyName' ? ErrorText.field : ''}
                    onChange={handleChange}
                    value={inputs?.companyName}
                    disabled={disables}
                  />
                </div>
                <div className='input-wrapper'>
                  <SelectInput
                    className={info?.companyType && globalStyles.inputTextFieldBlue}
                    style={globalStyles.simpleInputNoRight}
                    name={'companyType'}
                    label={'Company Type'}
                    handleSelect={handleChange}
                    value={inputs?.companyType}
                    list={company}
                    typeError={error === 'companyType' ? ErrorText.field : ''}
                    type={'id'}
                    disabled={disables}
                  />
                </div>


                {carrierInfo?.companyTypeList &&
                  <div className='input-wrapper'>
                    <SelectInput
                      className={info?.docketType && globalStyles.inputTextFieldBlue}
                      style={globalStyles.simpleInputNoRight}
                      name={'docketType'}
                      label={'Type*'}
                      handleSelect={handleChange}
                      value={inputs?.docketType}
                      list={carrierInfo?.companyTypeList}
                      typeError={error === 'docketType' ? ErrorText.field : ''}
                      type={'id'}
                      disabled={disables}
                    />
                  </div>
                }

                {userType === 'ADMIN' &&
                  <div className='input-wrapper'>
                    <ValidationInput
                      className={info?.taxId && globalStyles.inputTextFieldBlue}
                      style={globalStyles.simpleInputNoRight}
                      variant={'outlined'}
                      name={'taxId'}
                      label={'Tax ID'}
                      typeError={error === 'taxId' ? ErrorText.field : ''}
                      onChange={handleChange}
                      value={inputs?.taxId}
                      disabled={disables}
                    />
                  </div>
                }

                {carrierInfo?.noAuthority &&
                  <div className='input-wrapper'>
                    <ValidationInput
                      className={info?.docketNumber && globalStyles.inputTextFieldBlue}
                      style={globalStyles.simpleInputNoRight}
                      variant={'outlined'}
                      name={'docketNumber'}
                      label={carrierInfo?.authorityNumberName}
                      type={'text'}
                      typeError={
                        error === 'docketNumber' ? ErrorText.field :
                          errorText === 'A Carrier with this Authority Number already exists.' ? 'A Carrier with this Authority Number already exists.' :
                            ''}
                      onChange={handleChange}
                      value={inputs?.docketNumber}
                      disabled={disables}
                      Length={20}
                    />
                  </div>

                }



                <div className="input-wrapper" style={{ position: 'relative' }}>
                  {info?.type === vendorEnums.CARRIER && info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY &&
                    <div className="status-box"
                         style={{
                           right: '2px', zIndex: '2', top: '10px', position: 'absolute',
                           background: renderGoHighwayInfoStatus(info?.isDotActive ? 'Active' : 'Inactive')?.backgroundColor,
                         }}
                    >
                      <div
                        style={{ background: renderGoHighwayInfoStatus(info?.isDotActive ? 'Active' : 'Inactive')?.circleColor }} />
                      <p style={{ color: renderGoHighwayInfoStatus(info?.isDotActive ? 'Active' : 'Inactive')?.color }}>
                        {renderGoHighwayInfoStatus(info?.isDotActive ? 'Active' : 'Inactive')?.text}
                      </p>
                    </div>
                  }
                  <ValidationInput
                    className={info?.dot && globalStyles.inputTextFieldBlue}
                    style={globalStyles.simpleInputNoRight}
                    variant={'outlined'}
                    name={'dot'}
                    type={'number'}
                    label={'USDOT Number'}
                    typeError={error === 'dot' ? ErrorText.field : ''}
                    onChange={handleChange}
                    value={inputs?.dot}
                    disabled={disables}
                  />
                </div>

                {carrierInfo?.expDate &&
                  <div className='input-wrapper'>
                    <ValidationInput
                      className={info?.insuranceExpiry && globalStyles.inputTextFieldBlue}
                      style={globalStyles.simpleInputNoRight}
                      variant={'outlined'}
                      name={'insuranceExpiry'}
                      label={carrierInfo?.expDate}
                      type={'date'}
                      typeError={error === 'insuranceExpiry' ? ErrorText.field : ''}
                      onChange={handleChange}
                      value={info?.insuranceExpiry ? moment(inputs.insuranceExpiry).format('YYYY-MM-DD') : inputs?.insuranceExpiry}
                      disabled={disables}
                    />
                  </div>
                }

                {carrierInfo?.businessLicense ?
                  <div className='input-wrapper'>
                    <ValidationInput
                      className={info?.businessLicense && globalStyles.inputTextFieldBlue}
                      style={globalStyles.simpleInputNoRight}
                      variant={'outlined'}
                      name={'businessLicense'}
                      type={'number'}
                      label={'Business License Number'}
                      typeError={error === 'businessLicense' ? ErrorText.field : ''}
                      onChange={handleChange}
                      value={inputs?.businessLicense}
                      disabled={disables}
                    />
                  </div>
                  :
                  <div className='input-wrapper'></div>
                }

                {info?.type === vendorEnums.CARRIER &&
                  <div className='carrier-inputs-wrapper full-width' style={{ margin: 0 }}>
                    <div className='input-wrapper' style={{ width: '24%' }}>
                      <ValidationInput
                        className={info?.dbaName && globalStyles.inputTextFieldBlue}
                        style={globalStyles.simpleInputNoRight}
                        variant={'outlined'}
                        name={'dbaName'}
                        type={'text'}
                        label={'DBA Name'}
                        onChange={handleChange}
                        value={inputs?.dbaName}
                        disabled={disables}
                      />
                    </div>
                    <div className='input-wrapper' style={{ width: '24%' }}>
                      <ValidationInput
                        className={info?.scac && globalStyles.inputTextFieldBlue}
                        style={globalStyles.simpleInputNoRight}
                        variant={'outlined'}
                        name={'scac'}
                        type={'text'}
                        label={'SCAC Code'}
                        onChange={handleChange}
                        value={inputs?.scac}
                        disabled={disables}
                      />
                    </div>
                    <div className='input-wrapper' style={{ width: '24%' }}>
                      <ValidationInput
                        className={info?.mcNumber && globalStyles.inputTextFieldBlue}
                        style={globalStyles.simpleInputNoRight}
                        variant={'outlined'}
                        name={'mcNumber'}
                        type={'number'}
                        label={'MC Number'}
                        onChange={handleChange}
                        value={inputs?.mcNumber}
                        disabled={disables}
                      />
                    </div>
                    <div className='input-wrapper' style={{ width: '24%' }}>
                      <ValidationInput
                        className={info?.intrastateNumber && globalStyles.inputTextFieldBlue}
                        style={globalStyles.simpleInputNoRight}
                        variant={'outlined'}
                        name={'intrastateNumber'}
                        type={'number'}
                        label={'CA Number'}
                        onChange={handleChange}
                        value={inputs?.intrastateNumber}
                        disabled={disables}
                      />
                    </div>
                  </div>
                }

                <div className='input-wrapper'></div>
              </div>
            </div>
          }

          <div className={globalScreens.basicInfo}>
            <p className={globalText.smallText}>Company Address</p>
            <div className={globalScreens.basicInfoInputs}>
              <FormatAddress
                placeholder={'Physical Address'}
                notRequired={true}
                noBlue={!info?.address}
                setCurrentAddress={handleSetAddress}
                selectedAddress={info?.address}
                errorBoolean={error === 'address'}
                disabled={disables}
              />
            </div>
          </div>


          {/*{info?.type === vendorEnums.CARRIER && info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY &&*/}
          {/*  <div style={{ margin: '0px' }}>*/}
          {/*    <div className='insurance-info-wrapper' style={{ flexDirection: 'column' }}>*/}

          {/*      <div style={{ width: '100%' }} className='flex-align-start'>*/}
          {/*        <div style={{ width: '32%' }}>*/}
          {/*          <p>Common Authority Status</p>*/}
          {/*          <div*/}
          {/*            className='status-box'*/}
          {/*            style={{ background: renderGoHighwayInfoStatus(info?.commonAuthStatus)?.backgroundColor }}*/}
          {/*          >*/}
          {/*            <div style={{ background: renderGoHighwayInfoStatus(info?.commonAuthStatus)?.circleColor }} />*/}

          {/*            <p style={{ color: renderGoHighwayInfoStatus(info?.commonAuthStatus)?.color }}>*/}
          {/*              {renderGoHighwayInfoStatus(info?.commonAuthStatus)?.text}*/}
          {/*            </p>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*        <div style={{ width: '32%' }}>*/}
          {/*          <p>Broker Authority Status</p>*/}
          {/*          <div className='status-box'*/}
          {/*               style={{ background: renderGoHighwayInfoStatus(info?.brokerAuthStatus)?.backgroundColor }}>*/}
          {/*            <div style={{ background: renderGoHighwayInfoStatus(info?.brokerAuthStatus)?.circleColor }} />*/}
          {/*            <p style={{ color: renderGoHighwayInfoStatus(info?.brokerAuthStatus)?.color }}>*/}
          {/*              {renderGoHighwayInfoStatus(info?.brokerAuthStatus)?.text}*/}
          {/*            </p>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*        <div style={{ width: '32%' }}>*/}
          {/*          <p>Contract Authority Status</p>*/}
          {/*          <div className='status-box'*/}
          {/*               style={{ background: renderGoHighwayInfoStatus(info?.contractAuthStatus)?.backgroundColor }}>*/}
          {/*            <div style={{ background: renderGoHighwayInfoStatus(info?.contractAuthStatus)?.circleColor }} />*/}
          {/*            <p style={{ color: renderGoHighwayInfoStatus(info?.contractAuthStatus)?.color }}>*/}
          {/*              {renderGoHighwayInfoStatus(info?.contractAuthStatus)?.text}*/}
          {/*            </p>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}

          {/*      <div style={{ padding: '16px 0 0 0', borderTop: '1px solid #E6ECF3', width: '100%' }}*/}
          {/*           className='flex-align-start'>*/}
          {/*        <div style={{ width: '32%' }}>*/}
          {/*          <p>Interstate Authority</p>*/}

          {/*          <div className='status-box'*/}
          {/*               style={{ background: renderGoHighwayInfoStatus(info?.interstateAuthStatus)?.backgroundColor }}>*/}
          {/*            <div style={{ background: renderGoHighwayInfoStatus(info?.interstateAuthStatus)?.circleColor }} />*/}
          {/*            <p style={{ color: renderGoHighwayInfoStatus(info?.interstateAuthStatus)?.color }}>*/}
          {/*              {renderGoHighwayInfoStatus(info?.interstateAuthStatus)?.text}*/}
          {/*            </p>*/}
          {/*          </div>*/}

          {/*          /!*<h6>{info?.interstateAuthStatus}</h6>*!/*/}
          {/*        </div>*/}
          {/*        <div style={{ width: '32%' }}>*/}
          {/*          <p>Operating Status</p>*/}
          {/*          <h6>{info?.operatingStatus}</h6>*/}
          {/*        </div>*/}
          {/*        <div style={{ width: '32%' }}>*/}
          {/*          <p>Authority Age</p>*/}
          {/*          <h6>{info?.authorityAge} y.</h6>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*}*/}
        </div>
      </div>

      <p>{error === 'Required field' ? error : ''}</p>

      {!info &&
        <CreateChancel
          loader={!!loader.length}
          classes={globalStyles.buttonsStyle}
          create={'Create'}
          chancel={'Cancel'}
          onCreate={handleCreate}
          onClose={() => history.push('/carriers')}
        />
      }
    </div>
  );
};
